// This interface will be used by the Emscripten Binary:
window.retrieveCollectables = async function () {
    console.log('Retrieving collectables...')

    console.log('Done!')
}
